<template>
  <div>
    <div
      v-if="!is2FaEnable"
      class="title"
    >
      2FA {{ $t("twoFA.title2faNoActive") }}
    </div>
    <div
      v-if="!is2FaEnable"
      class="panel"
    >
      <div class="twofa-img">
        <img
          v-if="imgURL"
          :src="imgURL"
        >
        <SpinnerLoader
          v-else
          size="200px"
          color="#5AC396"
        />
      </div>

      <div class="text-explain">
        {{ $t("twoFA.descriptionOne", { platform }) }}
      </div>
      <input
        v-if="!is2FaEnable"
        v-model="authCode"
        class="data-in"
        type="text"
        :placeholder="$t(`twoFA.enterGoogleCode`)"
      >

      <AuButton
        type="primary"
        :disabled="!codeLength"
        center
        @click="toEnable2Fa"
      >
        <img
          v-if="progress"
          src="/svg/dark/progress_rolling_green.svg"
          alt="progress"
        >
        {{ $t("twoFA.on") }}
      </AuButton>
    </div>
    <div
      v-if="is2FaEnable"
      class="title"
    >
      2FA {{ $t("twoFA.title2faActive") }}
    </div>
    <div
      v-if="is2FaEnable"
      class="panel"
    >
      <span class="text-explain">{{ $t("twoFA.descriptionTwo") }}</span>
      <input
        v-model="authCode"
        class="data-in"
        type="text"
        :placeholder="$t(`twoFA.enterGoogleCode`)"
      >
      <AuButton
        type="primary"
        :disabled="!codeLength"
        center
        @click="toDisable2Fa"
      >
        <img
          v-if="progress"
          src="/svg/dark/progress_rolling_green.svg"
          alt="progress"
        >
        {{ $t("twoFA.off") }}
      </AuButton>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";
import SpinnerLoader from "@/loaders/progress-spinner";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Au2FA",

  components: {
    SpinnerLoader
  },

  data() {
    return {
      progress: false,
      is2FaEnable: false,
      token2fa: "",
      imgURL: "",
      authCode: "",
      mTitle: ""
    };
  },

  computed: {
    ...mapGetters({
      isLightTheme: "isLightTheme"
    }),

    codeLength() {
      return this.authCode.length == 6;
    },

    platform() {
      return process.env.VUE_APP_PLATFORM;
    }
  },

  mounted() {
    if (!this.$auth.user().is2faEnabled) {
      this.get2FaQr();
    }
    this.is2FaEnable = this.$auth.user().is2faEnabled;
  },

  methods: {
    ...mapActions({
      get2Fa: "get2Fa",
      postEnable2Fa: "postEnable2Fa",
      postDisable2Fa: "postDisable2Fa"
    }),

    async get2FaQr() {
      try {
        let resp = await this.get2Fa(this.$auth.user().id);
        if (resp.status == "200") {
          this.token2fa = resp.data.token2fa;

          QRCode.toDataURL(resp.data.url)
            .then((url) => {
              this.imgURL = url;
            })
            .catch((error) => {
              console.log(error);
            });
        }
        else {
          console.log("Error:", resp.response.data.detail);
        }
      }
      catch (error) {
        console.log(error);
      }
    },

    async toEnable2Fa() {
      this.progress = true;
      const params = {
        is2faEnabled: true,
        token2fa: this.token2fa,
        authCode: this.authCode
      };
      try {
        let resp = await this.postEnable2Fa({ params: params });
        if (resp.status == "202") {
          this.$toast.success("2FA is on");
          await this.$auth.fetch();
          setTimeout(() => {
            this.progress = false;
            this.is2FaEnable = this.$auth.user().is2faEnabled;
            this.authCode = "";
          }, 2000);
        }
        else {
          this.progress = false;
          this.$toast.error("Error occurred while trying to enable two-factor authentication");
        }
      }
      catch (error) {
        this.progress = false;
        this.$toast.error("Error occurred while trying to enable two-factor authentication");
      }
    },

    async toDisable2Fa() {
      this.progress = true;
      const params = {
        is2faEnabled: false,
        authCode: this.authCode
      };
      try {
        let resp = await this.postDisable2Fa({ params: params });
        if (resp.status == "202") {
          this.$toast.success("2FA is off");
          await this.$auth.fetch();
          setTimeout(() => {
            this.progress = false;
            this.is2FaEnable = this.$auth.user().is2faEnabled;
            this.authCode = "";
            if (!this.$auth.user().is2faEnabled) {
              this.get2FaQr();
            }
          }, 2000);
        }
        else {
          this.progress = false;
          this.$toast.error("Error occurred while trying to disable two-factor authentication");
        }
      }
      catch (error) {
        this.progress = false;
        this.$toast.error("Error occurred while trying to disable two-factor authentication");
      }
    }
  }
};
</script>

<style scoped lang="scss">
.title {
  font-weight: 600;
  font-size: 22px;
  margin-bottom: 30px;
  justify-content: start;
  text-align: left;
  align-items: left;
}
.panel {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  max-width: 350px;
  border: 1px solid var(--color-70);
  border-radius: 20px;
  padding: 20px;
  background: var(--card-color);
}
.data-in {
  border-radius: 10px;
  border: 1px solid var(--color-70);
  padding: 15px;
  margin-bottom: 10px;

  &::placeholder {
    color: var(--color-50);
  }
}

.twofa-img {
  margin: 0 auto;
  height: 240px;
}

.text-explain {
  font-weight: 400;
  font-size: 14px;
  text-align: center;
  margin-top: 2px;
  margin-bottom: 10px;
  color: var(--color-50);
}
</style>
